import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-00890f0f")
const _hoisted_1 = { class: "form" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_text_field = _resolveComponent("text-field")!
  const _component_modal_content = _resolveComponent("modal-content")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    isOpen: _ctx.open,
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_modal_content, {
        title: "受講生用ページURL",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createVNode(_component_text_field, {
              inputVal: _ctx.studentRoomURL,
              "onUpdate:inputVal": _cache[0] || (_cache[0] = ($event: any) => (_ctx.studentRoomURL = $event)),
              type: "text",
              value: _ctx.studentRoomURL,
              showCopyBtn: true
            }, null, 8, ["inputVal", "value"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["isOpen"]))
}